// extracted by mini-css-extract-plugin
export var menuIcon = "_ot-0";
export var menuIconInline = "_ot-1";